module.exports = __webpack_public_path__ + "img/categorie-crustaces-famille-boutrais-big.b4cfdbaa.jpg";